@use "../../styles/variables" as vars;

.section {
  padding: clamp(40px, 5vw, 64px) clamp(26px, 3vw, 40px) clamp(48px, 6vw, 80px);
  background: vars.$color-page;
}

.layout {
  width: min(100%, 640px);
  margin: 0 auto;
}

.heading {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
  text-align: center;

  h1 {
    margin: 0 0 8px;
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    font-size: clamp(28px, 2.6vw, 34px);
    line-height: 1.1;
  }

  p {
    margin: 0;
    color: vars.$color-muted;
    font-size: 17px;
  }
}

.form {
  width: 100%;
  margin: 0 auto;
  padding: clamp(17px, 2.5vw, 22px);
  border-radius: vars.$radius-md;
  background: vars.$color-surface;
  box-shadow: 0 8px 32px rgb(0 0 0 / 10%);
}

.fields {
  display: grid;
  gap: 12px;
}

.twoColumns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 11px;
}

.formSection {
  display: grid;
  gap: 16px;

  & + & {
    margin-top: 6px;
    padding-top: 21px;
  }
}

.sectionTitle {
  margin: 0;
  color: vars.$color-primary;
  font-family: vars.$font-heavy;
  font-size: 17px;
  line-height: 1.2;
}

.checkboxGroup {
  display: grid;
  gap: 7px;
  padding: 0;
  border: 0;
  background: transparent;

  legend {
    margin-bottom: 3px;
    color: vars.$color-muted;
    font-family: vars.$font-medium;
    font-size: 15px;
  }
}

.checkboxOptions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 8px;
  margin-top: 4px;
}

.companionFields {
  display: grid;
  gap: 12px;
  padding-top: 2px;
}

.companionTitle {
  margin: 0;
  color: vars.$color-primary;
  font-family: vars.$font-heavy;
  font-size: 16px;
  font-weight: 700;
}

.checkboxGroup label,
.checkLine {
  display: flex;
    min-height: 36px;
  align-items: center;
  gap: 7px;
  padding: 3px 8px;
  border: 1px solid vars.$color-border;
  border-radius: vars.$radius-sm;
  background: vars.$color-surface;
  cursor: pointer;
  transition: border-color 0.3s ease, background-color 0.3s ease;

  &:has(input:checked) {
    border-color: vars.$color-secondary;
    background: #fff8d7;
  }

  span {
    font-size: 15px;
  }

  input {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    margin: 0;
    appearance: none;
    border: 1px solid #8b8b8b;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;

    &:checked {
      border-color: vars.$color-success;
      background: vars.$color-success;
      box-shadow: inset 0 0 0 3px #fff;
    }

    &:focus-visible {
      outline: 2px solid vars.$color-secondary;
      outline-offset: 2px;
    }
  }
}

.termCopy {
  flex: 1;
  font-size: 15px;
}

.contentTabs {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 0 2px 18px;
  border-bottom: 1px solid vars.$color-border;

  button {
    position: relative;
    min-height: 38px;
    padding: 0 2px 10px;
    border: 0;
    background: transparent;
    color: vars.$color-muted;
    cursor: pointer;
    font-family: vars.$font-heavy;
    font-size: 16px;
    transition: color 0.2s ease;

    &:focus-visible {
      outline: 2px solid vars.$color-secondary;
      outline-offset: 2px;
    }

    &::after {
      position: absolute;
      right: 0;
      bottom: -1px;
      left: 0;
      height: 3px;
      border-radius: 3px 3px 0 0;
      background: transparent;
      content: "";
    }
  }

  .activeTab {
    color: vars.$color-primary;

    &::after {
      background: vars.$color-secondary;
    }
  }
}

.faqList {
  display: grid;
  max-height: 330px;
  overflow-y: auto;
  padding-right: 7px;
  border-top: 1px solid vars.$color-border;
  overscroll-behavior: contain;
  scrollbar-color: #b5b5b5 transparent;
  scrollbar-width: thin;
}

.faqIntro {
  margin: 0;
  padding: 10px 2px 12px;
  border-bottom: 1px solid vars.$color-border;
  color: vars.$color-muted;
  font-size: 14px;
  line-height: 1.45;
}

.faqItem {
  border-bottom: 1px solid vars.$color-border;

  summary {
    padding: 11px 2px;
    color: vars.$color-text;
    cursor: pointer;
    font-family: vars.$font-heavy;
    font-size: 15px;
    line-height: 1.25;
  }

  &[open] {
    summary {
      color: vars.$color-primary;
    }
  }

}

.faqAnswer {
  padding: 0 2px 12px 18px;
  color: vars.$color-muted;
  font-size: 14px;
  line-height: 1.45;

  p {
    margin: 0 0 8px;
  }

  p:last-child,
  ul:last-child,
  section:last-child ul {
    margin-bottom: 0;
  }

  ul {
    margin: 0 0 9px;
    padding-left: 17px;
  }

  li + li {
    margin-top: 4px;
  }

  section + section {
    margin-top: 9px;
  }

  strong {
    display: block;
    margin-bottom: 3px;
    color: vars.$color-text;
    font-family: vars.$font-heavy;
  }
}

.rsvpSupport {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid vars.$color-border;
  color: vars.$color-muted;
  font-size: 14px;

  a {
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}

.whatsAppIcon {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  fill: #25d366;
}

.contactSeparator {
  color: vars.$color-border;
}

.checkLine {
  padding: 9px 11px;

  &:has(input:checked) {
    background: #fffdf5;
  }
}

.termTrigger {
  padding: 0;
  border: 0;
  background: transparent;
  color: vars.$color-primary;
  cursor: pointer;
  font: inherit;
  font-family: vars.$font-heavy;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.modalOverlay {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 18px;
  background: rgb(0 0 0 / 58%);
}

.termsModal {
  width: min(100%, 600px);
  max-height: min(82vh, 680px);
  overflow: hidden;
  border-radius: vars.$radius-md;
  background: vars.$color-surface;
  box-shadow: 0 18px 60px rgb(0 0 0 / 28%);

  &:focus {
    outline: none;
  }
}

.termsModal {
  width: min(100%, 780px);
}

.modalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 16px;
  background: #a6a6a6;
  color: #fff;

  h2 {
    margin: 0;
    font-family: vars.$font-heavy;
    font-size: 18px;
    line-height: 1.25;
  }

  button {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font-size: 22px;
    line-height: 1;
  }
}

.modalContent {
  max-height: calc(min(82vh, 680px) - 112px);
  overflow-y: auto;
  padding: 16px;
  color: vars.$color-muted;
  font-size: 15px;
  line-height: 1.6;

  p {
    margin: 0 0 12px;
  }

  h3 {
    margin: 15px 0 6px;
    color: vars.$color-text;
    font-family: vars.$font-heavy;
    font-size: 15px;
  }

  ul {
    columns: 2;
    margin: 0 0 12px;
    padding-left: 18px;
  }

  a {
    color: vars.$color-primary;
    font-weight: 700;
  }
}

.modalFooter {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 16px 16px;

  button,
  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    min-height: 36px;
    padding: 7px 16px;
    border: 0;
    border-radius: vars.$radius-sm;
    background: vars.$color-secondary;
    color: vars.$color-text;
    cursor: pointer;
    font-family: vars.$font-heavy;
    font-size: 15px;
    text-decoration: none;

    &:hover {
      filter: brightness(0.96);
    }
  }
}

.documentDownload {
  background: #ecebea !important;
  color: vars.$color-text !important;
}

.termsContent {
  line-height: 1.5;

  p {
    margin: 0;
  }

  ul {
    columns: initial;
    margin: 8px 0 0;
    padding: 0;
    list-style: none;
  }
}

.termsDocumentHeader {
  display: grid;
  gap: 4px;
  margin-bottom: 22px;
  text-align: center;

  strong {
    color: vars.$color-text;
    font-family: vars.$font-heavy;
    font-size: 18px;
  }

  span {
    color: vars.$color-text;
    font-family: vars.$font-medium;
    font-size: 14px;
  }

  small {
    margin-top: 4px;
    color: vars.$color-muted;
    font-size: 12px;
  }
}

.termsSection {
  & + & {
    margin-top: 22px;
  }

  h3 {
    margin: 0 0 12px;
    color: vars.$color-primary;
    font-size: 17px;
  }
}

.termsParagraph {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 8px;
  font-size: 14px;

  & + & {
    margin-top: 10px;
  }
}

.termsMarker {
  color: vars.$color-text;
  font-family: vars.$font-heavy;
}

.termsChildren {
  display: grid;
  gap: 7px;

  li {
    display: grid;
    grid-template-columns: 34px minmax(0, 1fr);
    gap: 7px;
  }

  span {
    color: vars.$color-text;
    font-family: vars.$font-heavy;
  }
}

.checkLine {
  label {
    flex: 1;
    cursor: pointer;
    font-size: 15px;
  }

  strong {
    font-family: vars.$font-heavy;
  }

  a {
    color: vars.$color-primary;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}

.infoBox,
.notice {
  padding: 11px;
  border-left: 5px solid vars.$color-secondary;
  border-radius: vars.$radius-sm;
  background: #fff8d7;

  p {
    margin: 6px 0 0;
    font-size: 15px;
  }

  > p:first-child {
    margin-top: 0;
  }

  h3 {
    margin: 0;
    color: vars.$color-primary;
  }

  h2 {
    margin: 0;
    color: vars.$color-primary;
    font-size: 18px;
  }
}

.fieldError,
.submitError {
  color: vars.$color-error;
  font-size: 13px;
  font-weight: 700;
}

.invalidChoice {
  color: vars.$color-primary;
  animation: shake 0.3s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
}

.submitError {
  margin-top: 14px;
  padding: 9px;
  border: 1px solid vars.$color-error;
  border-radius: vars.$radius-sm;
  background: #fef3f2;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
}

.primaryButton,
.secondaryButton {
  min-height: 38px;
  padding: 7px 18px;
  border-radius: vars.$radius-sm;
  border: 0;
  font-family: vars.$font-heavy;
  font-size: 16px;
  transition: filter 0.2s ease, box-shadow 0.2s ease;

  &:hover:not(:disabled) {
    filter: brightness(0.96);
  }

  &:active:not(:disabled) {
    filter: brightness(0.92);
  }
}

.primaryButton {
  width: min(100%, 230px);
  background: vars.$color-secondary;
  color: vars.$color-text;
  box-shadow: vars.$shadow-button;

  &:disabled {
    cursor: wait;
    opacity: 0.7;
  }
}

.secondaryButton {
  width: 130px;
  background: #a6a6a6;
  color: #fff;
}

@media (min-width: 1081px) {
  .section {
    display: flex;
    align-items: flex-start;
  }

  .layout {
    flex: 0 1 640px;
  }
}

@media (max-width: 600px) {
  .heading {
    h1 {
      font-size: 28px;
    }

    p {
      font-size: 14px;
    }
  }

  .sectionTitle {
    font-size: 15px;
  }

  .checkboxGroup legend {
    font-size: 13px;
  }

  .companionTitle {
    font-size: 14px;
  }

  .checkboxGroup label,
  .checkLine {
    min-height: 34px;

    span {
      font-size: 13px;
    }
  }

  .termCopy,
  .checkLine label {
    font-size: 13px;
  }

  .contentTabs button {
    min-height: 36px;
    font-size: 14px;
  }

  .faqList {
    max-height: 45vh;
  }

  .faqIntro,
  .faqAnswer,
  .rsvpSupport {
    font-size: 12px;
  }

  .faqItem summary {
    font-size: 13px;
  }

  .whatsAppIcon {
    width: 16px;
    height: 16px;
  }

  .modalHeader h2 {
    font-size: 16px;
  }

  .modalContent,
  .modalContent h3,
  .modalFooter button,
  .modalFooter a,
  .infoBox p,
  .notice p {
    font-size: 13px;
  }

  .termsDocumentHeader strong {
    font-size: 16px;
  }

  .termsDocumentHeader span,
  .termsParagraph {
    font-size: 13px;
  }

  .termsParagraph {
    grid-template-columns: 40px minmax(0, 1fr);
    gap: 6px;
  }

  .termsChildren li {
    grid-template-columns: 30px minmax(0, 1fr);
  }

  .modalFooter {
    flex-wrap: wrap;

    button,
    a {
      flex: 1 1 140px;
    }
  }

  .infoBox h2,
  .notice h2 {
    font-size: 16px;
  }

  .fieldError,
  .submitError {
    font-size: 11px;
  }

  .primaryButton,
  .secondaryButton {
    min-height: 40px;
    font-size: 14px;
  }
}

@media (min-width: 1081px) and (max-height: 1250px) {
  .heading {
    gap: 5px;
    margin-bottom: 10px;

    h1 {
      margin-bottom: 4px;
    }
  }

  .form {
    padding: 16px 18px;
  }

  .fields {
    gap: 8px;
  }

  .formSection {
    gap: 10px;

    & + & {
      margin-top: 2px;
      padding-top: 12px;
    }
  }

  .companionFields {
    gap: 8px;
  }

  .actions {
    margin-top: 14px;
  }

  .primaryButton,
  .secondaryButton {
    min-height: 38px;
  }
}

@media (max-width: 600px) {
  .modalOverlay {
    place-items: end center;
    padding: 0;
  }

  .termsModal {
    width: 100%;
    max-height: 86vh;
    border-radius: vars.$radius-md vars.$radius-md 0 0;
  }

  .section {
    padding: 18px 10px;
  }

  .heading {
    margin-bottom: 16px;
  }

  .form {
    padding: 16px 13px;
    box-shadow: 0 6px 24px rgb(0 0 0 / 9%);
  }

  .twoColumns {
    grid-template-columns: 1fr;
  }

  .actions {
    flex-direction: column-reverse;
  }

  .primaryButton,
  .secondaryButton {
    width: 100%;
  }
}

@media (min-width: 1081px) {
  .heading {
    h1 {
      font-size: clamp(23px, 2.07vw, 27px);
    }

    p {
      font-size: 14px;
    }
  }

  .sectionTitle {
    font-size: 14px;
  }

  .checkboxGroup {
    legend {
      font-size: 13px;
    }
  }

  .companionTitle {
    font-size: 13px;
  }

  .checkboxGroup label,
  .checkLine {
    min-height: 32px;

    span {
      font-size: 13px;
    }
  }

  .termCopy,
  .checkLine label {
    font-size: 13px;
  }

  .contentTabs button {
    min-height: 34px;
    font-size: 13px;
  }

  .faqIntro,
  .faqAnswer,
  .rsvpSupport {
    font-size: 11px;
  }

  .faqItem summary {
    font-size: 13px;
  }

  .whatsAppIcon {
    width: 14px;
    height: 14px;
  }

  .modalHeader h2 {
    font-size: 14px;
  }

  .modalContent,
  .modalContent h3,
  .modalFooter button,
  .infoBox p,
  .notice p {
    font-size: 13px;
  }

  .infoBox h2,
  .notice h2 {
    font-size: 14px;
  }

  .fieldError,
  .submitError {
    font-size: 11px;
  }

  .primaryButton,
  .secondaryButton {
    min-height: 34px;
    font-size: 13px;
  }
}
